import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom, Observable } from 'rxjs';
import { PreSignPostResponse } from './upload-auth.service';

@Injectable({
  providedIn: 'root',
})
export class UploadPublicService {
  constructor(private http: HttpClient) {}

  private getPreSignedPostData(fileName: string): Observable<PreSignPostResponse> {
    return this.http.get<PreSignPostResponse>(`/api/v1/pre-sign-post-public?filename=${fileName}`);
  }

  public async uploadFile(file: File): Promise<string> {
    return await firstValueFrom(this.getPreSignedPostData(file.name))
      .then((response: PreSignPostResponse) => {
        const { url: uploadUrl, fileUrl } = response;

        this.http.put(uploadUrl, file).subscribe({
          error: () => alert('Error uploading file'),
        });

        return fileUrl;
      })
      .catch((error) => {
        alert('Error uploading file');

        return '';
      });
  }

  public downloadFile(fileUrl: string): void {
    window.open(fileUrl, '_blank');
  }
}
